export const P0003607PositionTypeEnum = [
  { ref: 0, label: 'P0003607.positiontype.0' },
  { ref: 1, label: 'P0003607.positiontype.1' },
];
